import React from "react"
import { graphql, PageProps } from "gatsby"

import { Layout } from "@interia/common/components/layout"
import Seo from "../components/seo/seo"
import useAboutusPageData from "../hooks/useAboutusPageData"
import { Mission, AboutUs, History, Events, Managment } from "../components/sections"
import Timelines from "../components/sections/timelines/timelines"
import useMainMenu from "../hooks/useMainMenu"
import useFooter from "../hooks/useFooter"


type DataProps = {
  site: {
    siteMetadata: {
      title: string
    }
  }
}

const ONasPage = ({ data: { site } }: PageProps<DataProps>) => {
  const siteTitle = site.siteMetadata.title
  const { mission, openGraph, aboutus, history, events, timelines, managment } = useAboutusPageData()
  const menuItems = useMainMenu()
  const footer = useFooter()

  return (
    <Layout footer={footer} gemiusId='0nKacee.fzah6lJ8915YdYZR7FlRDyyXVPlG5jJtFhH.P7' logoUrl={{ external: false, url: '/' }} menuItems={menuItems} actualSite="o-nas">
      <Seo title={siteTitle} openGraph={openGraph} />
      {mission.active && <Mission title={mission.title} description={mission.description} aboutuspage={true} />}
      {aboutus.active && <AboutUs description={aboutus.description} image={aboutus.image} />}
      {managment.active && <Managment title={managment.title} members={managment.members} />}
      {history.active && <History title={history.title} description={history.description} image={history.image} />}
      {events.active && <Events title={events.title} events={events.events} />}
      {timelines.active && <Timelines timelines={timelines.timelines} />}
    </Layout>
  )
}

export default ONasPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
